module.exports = __webpack_public_path__ + "img/r-180.022eb54c.jpg";